import { map } from 'lodash';

import type { TaskDetails } from '@/task-manager/entities/task-details';

import {
  type GetCardDetailViewOutputAlertInfos,
  type GetCardDetailViewOutputCard,
  type GetCardDetailViewOutputCardCustomField,
  type GetCardDetailViewOutputCommentRead,
  type GetCardDetailViewOutputDevice,
  type GetCardDetailViewOutputWorkstreamProjectDetails,
} from '../fetch-client';

import { alertInfoMapper } from './alert-info';
import { taskCardTypeMapper } from './task-card-type';
import { taskCommentMapper } from './task-comments';
import { customFieldMapper } from './task-custom-field';
import { deviceMapper } from './task-device';
import { taskPriorityMapper } from './task-priority';
import { taskProjectManagementMapper } from './task-project-management';
import { taskStatusMapper } from './task-status';
import { taskUserMapper } from './task-user';

export function taskDetailsMapper(
  dataCard: GetCardDetailViewOutputCard,
  dataDevice: GetCardDetailViewOutputDevice | undefined,
  dataAlertInfo: GetCardDetailViewOutputAlertInfos | undefined,
  comments: GetCardDetailViewOutputCommentRead[],
  didScoreReset: boolean,
  customFields: GetCardDetailViewOutputCardCustomField[] | undefined,
  isSubscribed: boolean,
  workstream: GetCardDetailViewOutputWorkstreamProjectDetails | undefined,
): TaskDetails {
  return {
    id: dataCard.uuid,
    title: dataCard.title,
    subtitle: dataCard.subtitle,
    description: dataCard.description,
    status: taskStatusMapper(dataCard.status),
    priority: taskPriorityMapper(dataCard.priority),
    createdBy: taskUserMapper(dataCard.created_by),
    assignee: dataCard.assignee ? taskUserMapper(dataCard.assignee) : undefined,
    dueAt: dataCard.due_date ? new Date(dataCard.due_date) : undefined,
    createdAt: new Date(dataCard.created_at),
    modifiedAt: new Date(dataCard.modified_at),
    device: dataDevice ? deviceMapper(dataDevice) : undefined,
    comments: map(comments, taskCommentMapper),
    canResetScore: !didScoreReset,
    isSubscribed: isSubscribed,
    customFields: map(customFields, customFieldMapper),
    cardType: taskCardTypeMapper(dataCard.card_type),
    alert: dataAlertInfo ? alertInfoMapper(dataAlertInfo) : undefined,
    projectManagement: taskProjectManagementMapper(workstream),
  };
}
